import React from 'react';
import update from 'react-addons-update';
import {injectIntl, intlShape} from 'react-intl';
import NewGroup from './NewGroup';
import NewConversation from './NewConversation';
import MenuBar from './MenuBar';
import {NEW_CONVERSATION_FORM_STATE, CONVERSATION_TYPES} from './constants';
import {inject, observer} from "mobx-react";

@inject('uiStore', 'conversationsStore', 'contactsStore' ) @observer
class NewConversationContainer extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      participant: null,
      viewState: NEW_CONVERSATION_FORM_STATE.PARTICIPANT_SELECTION,
    }
    this.handleAddParticipantClick = this.handleAddParticipantClick.bind(this);
    this.handleBodySubmit = this.handleBodySubmit.bind(this);
    this.handleClickBack = this.handleClickBack.bind(this);
    this.getSelectedParticipant = this.getSelectedParticipant.bind(this);
    this.showParticipantsSelection = this.showParticipantsSelection.bind(this);
  }

  render(){
    return(
      <div>
        <MenuBar
          onClickBack={this.handleClickBack}
          showBackBtn={true}
          title={this.menuBarTitle()}
        />
        <NewConversation
          viewState={this.state.viewState}
          onAddParticipantClick={this.handleAddParticipantClick}
          onBodySubmit={this.handleBodySubmit}
          showNewGroupBtn={true}
        />
      </div>
    );
  }

  handleAddParticipantClick(contactId){
    let conversation = this.props.conversationsStore.getPairConversationWithContact(contactId);
    // A conversation with the given contact already exists.
    // So we have to just open it.
    if( conversation ){
      conversation.openConversation();
    }
    // Go to the last step in the creation of a new conversation
    else{
      this.setState({
        participant: contactId,
        viewState: NEW_CONVERSATION_FORM_STATE.BODY_DEFINITION,
      });
    }
  }

  handleBodySubmit(body){
    if( body.length > 0 && this.state.participant != null ){
      this.props.uiStore.showLoading();
      this.props.conversationsStore.create(null, body, [this.state.participant], CONVERSATION_TYPES.PAIR );
    }
  }

  /************** MENU BAR ****************************/
  handleClickBack(){
    switch(this.state.viewState){
      case NEW_CONVERSATION_FORM_STATE.BODY_DEFINITION:
        this.showParticipantsSelection();
        break;
      case NEW_CONVERSATION_FORM_STATE.PARTICIPANT_SELECTION:
      default:
        this.props.uiStore.handleClickBack();
    }
  }

  menuBarTitle(){
    let title ="";
    const {intl} = this.props;
    let participant = this.getSelectedParticipant();
    switch(this.state.viewState){
      case NEW_CONVERSATION_FORM_STATE.BODY_DEFINITION:
        title = (participant && participant.name) || title;
        break;
      case NEW_CONVERSATION_FORM_STATE.PARTICIPANT_SELECTION:
        title = intl.formatMessage({id: "new_conversation_participant_title"});
        break;
    }
    return title;
  }

  getSelectedParticipant(){
    let participant;
    if( this.state.participant ){
      participant = this.props.contactsStore.contacts.filter( (el) => el.id == this.state.participant )
      if( participant.length > 0 ){
        return participant[0];
      }
    }

    return null;
  }

  showParticipantsSelection(){
    this.setState({
      viewState: NEW_CONVERSATION_FORM_STATE.PARTICIPANT_SELECTION,
    });
  }
  /****************************************************/

}

export default injectIntl(NewConversationContainer);